import * as React from 'react';
import { Box, Grid, Button, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TextField, Chip, Typography, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


const GetTimeFormat = (time) => {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    hours = Math.floor(time / 3600);
    minutes = Math.floor((time - (hours * 3600)) / 60);
    seconds = time - (hours * 3600) - (minutes * 60);

    if (hours == 0) {
        hours = '';
    }
    else {
        hours = hours + ' H ';
    }


    if (minutes == 0) {
        minutes = '';
    }
    else {
        minutes = minutes + ' M ';
    }

    if (seconds == 0) {
        seconds = '';
    }
    else {
        seconds = seconds + ' S ';
    }


    let final_time = hours + minutes + seconds;

    if (final_time == '') {
        final_time = 0
    }

    return final_time;
}

export const InstituteCallLogsComp = (props) => {
    return (
        <Box>
            <Box>
                <Grid container>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtSearchStartDate')} label="Start Date" value={dayjs(props.mystate.txtSearchStartDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtSearchEndDate')} label="End Date" value={dayjs(props.mystate.txtSearchEndDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>

                    <Grid xs={12} md={3}>
                        <Box>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.mystate.ddlSearchUser}
                                    label="Select User"
                                    onChange={(e) => props.HandleInputs(e, 'ddlSearchUser')}
                                >
                                    <MenuItem value={'All'} selected>{'All'}</MenuItem>
                                    {
                                        props.mystate.userListData.length > 0 ?

                                            props.mystate.userListData.map((item) =>
                                                item.user_profile_name.includes('Sales') ?
                                                    <MenuItem value={item.user_name}>{item.user_name}</MenuItem>
                                                    :
                                                    null
                                            )
                                            :
                                            null
                                    }
                                </TextField>

                            </FormControl>
                        </Box>
                    </Grid>



                    <Grid md={2}>
                        <Box textAlign={'end'}>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.CustomSearch()}><SearchIcon></SearchIcon></Button>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.Reload()}><CachedIcon></CachedIcon></Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box style={{ marginTop: '20px' }}>

                {
                    props.mystate.getCallLogsCount === false ?
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 'calc(100vh - 200px)' }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>

                                            <TableCell className="table-head-cell">
                                                Rank
                                            </TableCell>

                                            <TableCell className="table-head-cell">
                                                Sales Executive
                                            </TableCell>

                                            <TableCell
                                                className="table-head-cell"
                                                align="center"
                                            >
                                                Dialled
                                            </TableCell>

                                            <TableCell
                                                className="table-head-cell"
                                                align="center"
                                            >
                                                Connected
                                            </TableCell>

                                            <TableCell className="table-head-cell">
                                                Total Talktime
                                            </TableCell>

                                            <TableCell className="table-head-cell">
                                                Avg Talktime
                                            </TableCell>

                                            <TableCell className="table-head-cell">
                                                Lead Progress
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.mystate.callCountData.length > 0 ?
                                            props.mystate.callCountData.map((item, i) => (
                                                item.user_name != undefined && item.user_name != '' ?
                                                    <TableRow
                                                        hover
                                                        key={i}
                                                        sx={{
                                                            '&:hover': {
                                                                backgroundColor: '#f8fafc'
                                                            }
                                                        }}
                                                    >

                                                        <TableCell>

                                                            <Chip
                                                                label={`#${i + 1}`}
                                                                size="small"
                                                                color={
                                                                    i === 0
                                                                        ? 'success'
                                                                        : i === 1
                                                                            ? 'primary'
                                                                            : 'default'
                                                                }
                                                            />

                                                        </TableCell>

                                                        <TableCell>

                                                            <Box>

                                                                <Typography
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: '#111827'
                                                                    }}
                                                                >
                                                                    {item.user_name}
                                                                </Typography>

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                >
                                                                    Sales Executive
                                                                </Typography>

                                                            </Box>

                                                        </TableCell>

                                                        <TableCell align="center">

                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    color: '#2563eb',
                                                                    cursor: 'pointer',
                                                                    textDecoration: 'underline'
                                                                }}
                                                                onClick={() =>
                                                                    props.OpenCallLogs(
                                                                        item.user_name,
                                                                        'DIALLED'
                                                                    )
                                                                }
                                                            >
                                                                {item.dialled}
                                                            </Typography>

                                                        </TableCell>

                                                        <TableCell align="center">

                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    color: '#16a34a',
                                                                    cursor: 'pointer',
                                                                    textDecoration: 'underline'
                                                                }}
                                                                onClick={() =>
                                                                    props.OpenCallLogs(
                                                                        item.user_name,
                                                                        'CONNECTED'
                                                                    )
                                                                }
                                                            >
                                                                {item.connected}
                                                            </Typography>

                                                            <Typography
                                                                variant="caption"
                                                                color="success.main"
                                                            >
                                                                {
                                                                    item.dialled > 0
                                                                        ? Math.round(
                                                                            (item.connected / item.dialled) * 100
                                                                        )
                                                                        : 0
                                                                }%
                                                            </Typography>

                                                        </TableCell>

                                                        <TableCell>
                                                            {GetTimeFormat(item.duration)}
                                                        </TableCell>

                                                        <TableCell>

                                                            {
                                                                item.duration > 0 &&
                                                                    item.connected > 0
                                                                    ? GetTimeFormat(
                                                                        Math.floor(
                                                                            item.duration /
                                                                            item.connected
                                                                        )
                                                                    )
                                                                    : '0'
                                                            }

                                                        </TableCell>

                                                        <TableCell>

                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    gap: 0.8,
                                                                    minWidth: 250
                                                                }}
                                                            >

                                                                <Chip
                                                                    size="small"
                                                                    color="error"
                                                                    variant="outlined"
                                                                    label={`RNR (${item.rnr || 0})`}
                                                                />

                                                                <Chip
                                                                    size="small"
                                                                    color="warning"
                                                                    variant="outlined"
                                                                    label={`Call Back (${item.call_back || 0})`}
                                                                />

                                                                <Chip
                                                                    size="small"
                                                                    color="success"
                                                                    variant="outlined"
                                                                    label={`Active (${item.active || 0})`}
                                                                />

                                                                <Chip
                                                                    size="small"
                                                                    color="primary"
                                                                    variant="outlined"
                                                                    label={`Onboarding (${item.onboarding || 0})`}
                                                                />

                                                                <Chip
                                                                    size="small"
                                                                    variant="outlined"
                                                                    label={`Inactive (${item.inactive || 0})`}
                                                                />

                                                            </Box>

                                                        </TableCell>

                                                    </TableRow>
                                                    :
                                                    ''
                                            ))
                                            :
                                            "No Record Found"
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        :
                        <Box>
                            <Skeleton height={75} />
                            <Skeleton animation="wave" variant="rectangular" height={250} />
                            <Skeleton height={75} />
                        </Box>
                }

            </Box>

            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={props.mystate.showAlert} autoHideDuration={2000} onClose={() => { props.handleCloseAlert() }}>
                <Alert
                    onClose={() => { props.handleCloseAlert() }}
                    severity={'error'}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>

            <Dialog
                open={props.mystate.callLogsPopup}
                onClose={() => props.CloseCallLogs(false)}
                fullWidth
                maxWidth="lg"
            >

                <DialogTitle>

                    Call Logs

                    <Typography
                        variant="body2"
                        color="text.secondary"
                    >
                        {props.mystate.selectedUser} - {props.mystate.selectedType}
                    </Typography>

                </DialogTitle>

                <DialogContent>

                    <TableContainer>

                        <Table>

                            <TableHead>

                                <TableRow>

                                    <TableCell>
                                        Date
                                    </TableCell>

                                    <TableCell>
                                        From
                                    </TableCell>

                                    <TableCell>
                                        To
                                    </TableCell>

                                    <TableCell>
                                        Status
                                    </TableCell>

                                    <TableCell>
                                        Duration
                                    </TableCell>

                                    <TableCell>
                                        Recording
                                    </TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    props.mystate.callLogs.map((log, index) => (

                                        <TableRow key={index}>

                                            <TableCell>
                                                {log.call_start_time}
                                            </TableCell>

                                            <TableCell>
                                                {log.call_from_number}
                                            </TableCell>

                                            <TableCell>
                                                {log.call_to_number}
                                            </TableCell>

                                            <TableCell>

                                                <Chip
                                                    size="small"
                                                    color={
                                                        log.call_status === 'completed'
                                                            ? 'success'
                                                            : 'warning'
                                                    }
                                                    label={log.call_status}
                                                />

                                            </TableCell>

                                            <TableCell>
                                                {
                                                    GetTimeFormat(
                                                        log.duration || 0
                                                    )
                                                }
                                            </TableCell>

                                            <TableCell>

                                                {
                                                    log.recording_url ? (

                                                        <IconButton
                                                            onClick={() =>
                                                                window.open(
                                                                    log.recording_url,
                                                                    '_blank'
                                                                )
                                                            }
                                                        >
                                                            <PlayArrowIcon
                                                                color="primary"
                                                            />
                                                        </IconButton>

                                                    ) : (
                                                        '-'
                                                    )
                                                }

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                            </TableBody>

                        </Table>

                    </TableContainer>

                </DialogContent>

            </Dialog>
        </Box>


    );
}